import select from './DictItemSelect.vue'
const ZPGLFormDictItemSelect = {
  install: function (Vue) {
    Vue.component('ZPGLFormDictItemSelect', select)
  }
}
export default ZPGLFormDictItemSelect
